
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import {QInput} from "quasar"

const between = (v: number | null, min: number, max: number): boolean =>
  v == null || !Number.isFinite(v) || (v >= min && v <= max)

const clamp = (v: number | null, min: number, max: number): number | null =>
  v == null || !Number.isFinite(v) ? null : v < min ? min : v > max ? max : v

// a Min/Max pair of number inputs used by the advanced member filters -
// bounds-checks (via :rules) and clamps (on blur) both fields to
// [lowerBound, upperBound], and emits update:min/update:max for use with
// the .sync modifier
@Component({components: {QInput}})
export default class RangeNumberFilter extends Vue {
  @Prop()
  label: string

  @Prop({default: null})
  min: number | null

  @Prop({default: null})
  max: number | null

  @Prop()
  lowerBound: number

  @Prop()
  upperBound: number

  @Prop({default: false})
  noSpin: boolean

  get rules(): Array<(v: number | null) => boolean> {
    return [(v: number | null) => between(v, this.lowerBound, this.upperBound)]
  }

  get minValue(): number | null {
    return this.min
  }

  set minValue(v: number | null) {
    this.$emit("update:min", v)
  }

  get maxValue(): number | null {
    return this.max
  }

  set maxValue(v: number | null) {
    this.$emit("update:max", v)
  }

  private onBlur(field: "min" | "max") {
    const value = field === "min" ? this.min : this.max
    this.$emit(`update:${field}`, clamp(value, this.lowerBound, this.upperBound))
  }
}
